var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz"},[(_vm.isFinished)?_c('QuizResult'):_c('QuizCard',_vm._b({on:{"update-card":_vm.nextCard}},'QuizCard',_vm.currentCard,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }